import React, { FC } from 'react'
import styles from './GeneratePredictiveModelReportDialog.module.scss'
import { Dialog } from 'components/Dialog/Dialog'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { useFetchOrganization } from 'services/organization'
import { Icon } from 'components/Icon'
import { Table, TableHead, TableRow, TableHeadCell, TableBody, TableCell } from 'components/Table'
import { DateUtils } from 'utils/date'
import { useFetchPreviousPredictiveReports } from 'services/organization'

type Steps = 'confirm' | 'download'

type PreviousPredictiveReportsProps = {
    onClose: () => void
    isOpen: boolean
    predictiveModelId: string
}

export const PreviousPredictiveReports: FC<PreviousPredictiveReportsProps> = ({
    onClose,
    isOpen = false,
    predictiveModelId,
}) => {
    const { t } = useTranslation()
    const { organization, status: orgStatus } = useFetchOrganization()
    const { previousPredictiveReports } = useFetchPreviousPredictiveReports()


    if (!organization || orgStatus === 'loading') return null

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            aria-label={t('previous_predictive_reports.title')}
            className={styles.generatePredictiveModelReportDialog}
        >
            <Stack>
                <div>
                    <Heading>{t(`previous_predictive_reports.title`)}</Heading>
                    <Text>{t(`previous_predictive_reports.desc`)}</Text>
                </div>

            </Stack>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeadCell>
                            <Text weight="strong">{t('previous_predictive_reports.table.predictive_reports_created_by')}</Text>
                        </TableHeadCell>
                        <TableHeadCell>
                            <Text weight="strong">{t('previous_predictive_reports.table.predictive_reports_date')}</Text>
                        </TableHeadCell>
                        <TableHeadCell></TableHeadCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {previousPredictiveReports &&
                        previousPredictiveReports.map((previousPredictiveReport) => (
                            <TableRow key={previousPredictiveReport.createdby}>
                                <TableCell>
                                    <Text weight="strong">{previousPredictiveReport.createdby}</Text>
                                </TableCell>
                                <TableCell>
                                    <Text weight="strong">{DateUtils.short(previousPredictiveReport.date)}</Text>
                                </TableCell>
                                <TableCell>
                                    <a download aria-label={t('common.download')} href={previousPredictiveReport.url}>
                                        <Icon name="download-line"></Icon>
                                    </a>
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </Dialog>
    )
}

PreviousPredictiveReports.displayName = 'PreviousPredictiveReports'



